import { ICaremapNote } from './NotesClient';
import { FileUploader } from '../generic-notes/attachments/FileUploader';

export class NoteValidator {
    static inject = () => [FileUploader];
    constructor(private fileUploader: FileUploader){

    }

    // The uploader is a singleton, so this depends on state that changes outside any one note's
    // view model. Anything gated on this must therefore subscribe to the uploader in the COMPONENT
    // that renders the control — see useRerenderOnUploadChange. Miss that and the check is correct
    // but stale: a Save button that was enabled before the upload began stays enabled, and saving
    // drops the attachment without reporting anything.
    isValid = (note: ICaremapNote): boolean => {
        const hasOneOfRequiredFields = Boolean(note.html) || Boolean(note.title) || note.attachments.length > 0;
        return this.fileUploader.getUploadingCount() === 0 && hasOneOfRequiredFields;
    };
}
